import * as AsheCoreEditor from "@clover/ashe-core-editor";
import * as AsheCoreRuntime from "@clover/ashe-core-runtime";
import * as asheLibs from "@clover/ashe-libs";
import "url-search-params-polyfill";
import * as vue from "vue";
import { sendLog } from "./libs/sendLog";
import App from "./App.vue";
import { injectionDiscernCodeclipboard } from "./libs/lib";
import "./libs/polyfill";
import "./styles/index.css";

const params = new URLSearchParams(location.search);
const pageIdEcpt = params.get("pageIdEcpt");
const activityIdEcpt = params.get("activityIdEcpt");

try {
  sendLog("pef", "General_Operation_Activity_PageInit", {
    pageIdEcpt,
    activityIdEcpt,
  });
} catch (error) {}

window["Vue"] = vue;
globalThis["@clover/ashe-libs"] = asheLibs;
globalThis["AsheCoreEditor"] = AsheCoreEditor;
globalThis["AsheCoreRuntime"] = AsheCoreRuntime;

globalThis["ASHE-APP-ENV"] = process.env.VUE_APP_MODE;

injectionDiscernCodeclipboard();
const app = vue.createApp(App);
app.mount("#app");

app.config.errorHandler = (err, _, info) => {
  // 上报vue错误
  try {
    if (window["aegis"]) {
      window["aegis"].captureException(err);
    }
    sendLog("pef", "General_Operation_Activity_VUE_Error", {
      pageIdEcpt,
      activityIdEcpt,
      activityVueError: String(err),
      activityVueErrorInfo: String(info),
    });
  } catch (error) {}
  console.error(err);
};
